<template>
    <div class="w-full flex flex-column gap-6">
        <div class="w-full flex flex-column gap-2">
            <span class="flex text-900 font-medium text-3xl xl:text-6xl lg:text-5xl md:text-4xl justify-content-center">
                {{ content[lang].title }}
            </span>
            <span class="flex text-600 text-md justify-content-center">
                {{ content[lang].subtitle }}
            </span>
        </div>
        <div class="flex w-full flex-column justify-content-center align-items-center m-auto" style="max-width:640px;">
            <img src="/images/svg/bill_big_icon.svg" class="max-w-10rem m-auto mb-4">
            <span class="inline-block m-auto justify-content-center align-items-center text-center text-600 text-lg line-height-2">
                {{ content[lang].text }}
            </span>
        </div>

        <div class="flex flex-column gap-3 w-full max-w-30rem m-auto">
            <span class="flex text-600 text-md justify-content-center">{{ content[lang].titleTodo }}:</span>
            <MobMenu :items=[]>
                <template v-slot:body>
                    <!--TG-->
                    <div class="w-full flex flex-row px-3 py-2 border-100 cursor-pointer border-bottom-1" style="min-height:50px" @click="toProfile(isTelegram)">
                        <div class="flex mr-3 align-items-center">
                            <Avatar class="text-600" size="small" icon="pi pi-telegram" shape="circle"/>
                        </div>
                        <div class="flex flex-1 justify-content-left align-items-center">
                            <span class="text-600">{{ content[lang].doLinkTelegram }}</span>
                        </div>
                        <div class="flex justify-content-right align-items-center">
                            <i v-if="isTelegram" class="text-500 ml-2 pi pi-check" />
                            <i v-else class="text-blue-500 ml-2 pi pi-angle-right" />
                        </div>
                    </div>
                    <!--Verify-->
                    <div class="w-full flex flex-row px-3 py-2 border-100 cursor-pointer border-bottom-1" style="min-height:50px" @click="toVerify(isVerified)">
                        <div class="flex mr-3 align-items-center">
                            <Avatar class="text-600" size="small" icon="pi pi-verified" shape="circle"/>
                        </div>
                        <div class="flex flex-1 justify-content-left align-items-center">
                            <span class="text-600">{{ content[lang].doKYC }}</span>
                        </div>
                        <div class="flex justify-content-right align-items-center">
                            <i v-if="isVerified" class="text-500 ml-2 pi pi-check" />
                            <i v-else class="text-blue-500 ml-2 pi pi-angle-right" />
                        </div>
                    </div>
                </template>
            </MobMenu>
            <Button :label="content[lang].btn" @click="showRules=true" class="border-round-lg" :disabled="!isTelegram || !isVerified"/>
            <!-- <Button :label="content[lang].btn" @click="showRules=true" class="border-round-lg" /> -->
        </div>

        <div class="flex w-full flex-column faqStepsCom m-auto" style="max-width:640px;">
            <span class="flex text-700 align-items-center text-center font-medium mb-4 xl:mb-6 justify-content-center
                text-xl xl:text-4xl lg:text-5xl md:text-4xl">
                {{ content[lang].faq }}
            </span>
            <FaqShortList v-if="tabs" :tabs="tabs" :count="4" />
        </div>
    </div>

    <Dialog v-model:visible="showRules" :header="content[lang].agree_title" blockScroll modal
        :style="(screenSize=='xs' || screenSize=='sm' || screenSize=='md') ? { width: '100%', height: '100%' } : { width: '900px' }" 
        :contentStyle="(screenSize=='xs' || screenSize=='sm' || screenSize=='md') ? { height: '100%' } : { height: '500px' }"
        class=" mx-2">
        <div class="w-full">
           <Rules />
        </div>
        <template #footer>
            <span class="w-full flex flex-column">
                <div class="w-full flex flex-row gap-2 justify-content-start align-items-center py-2">
                    <Checkbox v-model="checked" :binary="true" class="flex" />
                    <span class="flex" @click="checked=!checked">{{ content[lang].agree }}</span>
                </div>
                <Button :label="content[lang].btnAccept" icon="pi pi-check" @click="be()" 
                    :loading="loading" :disabled="!checked || !isTelegram || !isVerified"
                    class="flex border-round-xl w-full" />
                <!-- <Button :label="content[lang].btnAccept" icon="pi pi-check" @click="be()" 
                    :loading="loading" :disabled="!checked"
                    class="flex border-round-xl w-full" /> -->
            </span>
        </template>
    </Dialog>

</template>

<script>
import Connect      from '@/assets/js/Connect'
import Helper       from '@/assets/js/Helper'
import MobMenu      from '@/components/sides/menu/MobMenu.vue'
import FaqShortList from '@/components/widgets/FaqList.vue'
import Rules        from '@/components/personal/bill/Rules.vue'

export default {
    data() {
        return {
            activeIndex: 0,
            showRules: false,
            checked: false,
            loading: false,
            content: {
                ru: {
                    title: 'Прием платежей',
                    subtitle: 'Как это работает',
                    text: 'Принимайте оплаты от своих клиентов прямо через PayWave. Вы можете выставить счет в любой валюте, указав сумму и реквизиты получателя (ваши). Отправляйте ссылку клиенту и отслеживайте оплаты через личный кабинет.',
                    text2: '*Для начала работы с сервисом вам необходимо пройти верификацию. Это подтверждение вашей личности и контактных данных. Мы обязательно проверим их, чтобы обеспечить безопасность ваших средств и данных.',
                    titleTodo: 'Требуется выполнить действия',
                    doLinkTelegram: 'Привязать Telegram',
                    doKYC: 'Пройти верификацию',
                    btn: 'Подключить',
                    btnAccept: 'Принять условия',
                    agree: 'Я согласен с условиями',
                    agree_title: 'Условия использования сервиса',
                    faq: 'Вопрос-ответ',
                    success: 'Успешно',
                    successText: 'Вы успешно подключились к программе приема платежей',
                    error: 'Ошибка',
                    errorText: 'Произошла ошибка при подключении к программе приема платежей'
				},
				en: {
                    title: 'Accept payments',
                    subtitle: 'How it works',
                    text: 'Verification is the confirmation of your identity and contact details. We will definitely check them to ensure the security of your funds and data.',
                    text2: '*Accept payments from your customers directly through PayWave. You can issue an invoice in any currency, specifying the amount and recipient details (yours). Send a link to the client and track payments through your personal account.',
                    titleTodo: 'You need to do the following',
                    doLinkTelegram: 'Link Telegram',
                    doKYC: 'Pass verification',
                    btn: 'Connect',
                    btnAccept: 'Accept terms',
                    agree: 'I agree to the terms',
                    agree_title: 'Terms of service',
                    faq: 'FAQ',
                    success: 'Success',
                    successText: 'You have successfully connected to the payment acceptance program',
                    error: 'Error',
                    errorText: 'An error occurred while connecting to the payment acceptance program'
				}
			},
            tabs: [
                {
                    ru: {
                        title: 'Зачем проходить верификацию',
                        content: 'Верификация - это подтверждение вашей личности и контактных данных. Мы обязательно проверим их, чтобы обеспечить безопасность ваших средств и данных'
                    },
                    en: {
                        title: 'Why do I need to be verified?',
                        content: 'Verification is the confirmation of your identity and contact details. We will definitely check them to ensure the security of your funds and data'
                    }
                },
                {
                    ru: {
                        title: 'Как создать свой первый счет',
                        content: 'Прямо в личном кабинете вы можете создать счет для своего клиента. Выставляйте счета в любой валюте, указав сумму и реквизиты получателя'
                    },
                    en: {
                        title: 'How to create your first bill',
                        content: 'Right in your personal account, you can create a bill for your client. Issue invoices in any currency, specifying the amount and recipient details'
                    }
                },
                {
                    ru: {
                        title: 'Как принять оплату',
                        content: 'Клиенты сделают перевод с карты на карту нашего доверенного лица в удобной им валюте, а вы получите деньги в валюте своего счета'
                    },
                    en: {
                        title: 'How to accept payment',
                        content: 'Customers will make a transfer from card to card of our trusted person in the currency convenient for them, and you will receive money in the currency of your account'
                    }
                },
                {
                    ru: {
                        title: 'Как отслеживать выплаты',
                        content: 'Все успешные переводы клиентов будут отображаться в вашем личном кабинете. Вы сможете видеть все оплаты и их статусы'
                    },
                    en: {
                        title: 'How to track payments',
                        content: 'All successful transfers of customers will be displayed in your personal account. You will be able to see all payments and their statuses'
                    }
                }
            ]
        }
    },
    components: {
        MobMenu,
        FaqShortList
    },
    computed: {
        lang() { return (this.$i18n.locale) ? this.$i18n.locale : 'ru' },
        screenSize() { return this.$store.getters.StateScreenSize },
        isDarkTheme() { return this.$store.getters.StateDarkTheme },
        isLoggedIn: function () { return this.$store.getters.isAuthenticated },
        isTelegram: function () { return this.$store.getters.StateTelegramUsername },
        isVerified: function () { return this.$store.getters.StateVerified },
    },
    methods: {
        showMess(severity, summary, detail) {
            this.$toast.add({severity: severity, summary: summary, detail: detail, life: 3000});
        },
        toProfile(isTelegram){
            if(isTelegram) return
            this.$router.push({path: '/personal/profile/'})
        },
        toVerify(isVerified){
            if(isVerified) return
            this.$router.push({path: '/verify/process/'})
        },
        async be() {
            this.loading = true
            const add = await this.connect.GetBillProgram().then(res=>res).catch(err=>err)
            if(add.result && add.data){
                this.showMess('success', this.content[this.lang].success, this.content[this.lang].successText)
                this.showRules = false
                try { await this.$store.dispatch('setAddGroup', 'bill').then(() => {}) } 
                catch {}
            } else {
                if(add.errors && add.errors.length > 0){
                    this.showMess('error', this.content[this.lang].error, add.errors[0])
                } else this.showMess('error', this.content[this.lang].error, this.content[this.lang].errorText)
            }
            this.loading = false
        }
    },
    beforeCreate() {
        this.connect = new Connect()
        this.helper = new Helper()
    },
    mounted() {
        this.helper.SetTgAppHeadColor('gray', this.isDarkTheme)
	}
}
</script>